import { ActionType } from '../../types';

export const ManageDeviceProfilesActions = {

    DeviceProfileSaveStarted: () =>
        ({
            type: 'DeviceProfile/Save/Started',
        } as const),

        DeviceProfileSaveSucceeded: (message: string, data: {}) =>
        ({
            type: 'DeviceProfile/Save/Succeeded',
            payload: { message, data },
        } as const),

        DeviceProfileSaveFailed: (errorCode: string) =>
        ({
            type: 'DeviceProfile/Save/Failed',
            payload: { errorCode },
        } as const),

        DeviceProfileSaveUnmounted: () =>
        ({
            type: 'DeviceProfile/Save/Unmounted',
        } as const),

        DeviceProfileSaveReset: () =>
        ({
            type: 'DeviceProfile/Save/Reset',
        } as const),
        
        SetSelectedDeviceProfileId: (deviceProfileId: string) =>
        ({
            type: 'DeviceProfile/SetSelectedDeviceProfileId',
            payload: {
                deviceProfileId,
            },
        } as const),

};

export type ManageDeviceProfilesActions = ActionType<typeof ManageDeviceProfilesActions>;
